import {
    SET_LIMIT_ACCESS_FIRE_TV,
    SET_APP_TYPE,
    SET_DEVICE_CAPABILITIES,
    SET_IS_APP_VIEW,
} from "./types";

export const setLimitAccessFireTv = (value) => (dispatch) => {
    dispatch({
        type: SET_LIMIT_ACCESS_FIRE_TV,
        payload: value,
    });
};

export const setAppType = (appType) => (dispatch) => {
    dispatch({
        type: SET_APP_TYPE,
        payload: appType,
    });
};

export const setDeviceCapabilities = (capabilities) => (dispatch) => {
    dispatch({
        type: SET_DEVICE_CAPABILITIES,
        payload: capabilities,
    });
};

export const setIsAppView = (isApp) => (dispatch) => {
    dispatch({
        type: SET_IS_APP_VIEW,
        payload: isApp,
    });
};